import Spacer from '@/common/components/spacer';
import { Button } from '@/shadcn-ui/button';
import { Skeleton } from '@/shadcn-ui/skeleton';
import { cn } from '@/shadcn-ui/utils';
import useRouteIsLoading from '@/util-react-router/hooks/use-route-is-loading';

interface EstimatedPricingProps {
  estimatedMonthlyCostCopy: string;
  estimatedMonthlySavingsCopy?: string;
  onClickDelegate?: () => void;
  className?: string;
  skeletonClassName?: string;
  compact?: boolean;
}

export default function EstimatedPricing({
  estimatedMonthlyCostCopy,
  estimatedMonthlySavingsCopy,
  onClickDelegate,
  className,
  skeletonClassName,
  compact = false,
}: EstimatedPricingProps) {
  const isLoading = useRouteIsLoading();

  const handleSavingsClick = () => {
    onClickDelegate?.();
  };

  return (
    <div
      className={cn(
        'flex w-fit flex-col lg:mb-[24px] lg:w-full lg:flex-row lg:items-center lg:justify-between',
        className
      )}
    >
      {isLoading ? (
        <div
          className={cn(
            'flex h-[48px] w-fit flex-col lg:h-fit lg:w-full lg:flex-row lg:items-center',
            skeletonClassName,
            {
              'justify-between': estimatedMonthlySavingsCopy,
              'justify-center lg:justify-start': !estimatedMonthlySavingsCopy,
            }
          )}
        >
          <div className="flex w-[160px] flex-col">
            <Spacer variant="height2" />
            <Skeleton className="h-[22px] w-full" />
          </div>
          {estimatedMonthlySavingsCopy ? (
            <div className="flex w-[120px] flex-col">
              <Spacer variant="height2" />
              <Skeleton className="h-[16px] w-full lg:h-[20px]" />
            </div>
          ) : null}
        </div>
      ) : (
        <>
          <p className="body-strong text-[18px] text-flexcar-neutral0">
            {compact ? '' : 'Total: '}
            {estimatedMonthlyCostCopy}
          </p>
          {estimatedMonthlySavingsCopy ? (
            <div className="flex items-center gap-[4px]">
              <Button
                variant="clear"
                type="button"
                onClick={handleSavingsClick}
                className="flex h-fit w-fit items-center justify-center"
              >
                <p className="homepage-hero-body2 cursor-pointer text-[14px] font-semibold text-flexcar-green40 underline decoration-flexcar-green40 decoration-dotted decoration-[2px] underline-offset-[4px] transition-all duration-100 hover:text-flexcar-green30 hover:decoration-flexcar-green30 lg:text-[16px]">
                  {estimatedMonthlySavingsCopy} savings
                </p>
              </Button>
              <p className="body-tight text-[14px] text-flexcar-neutral1 lg:text-[16px]">
                vs. buying
              </p>
            </div>
          ) : null}
        </>
      )}
    </div>
  );
}
